import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { serviceApi } from '~/features';
import { clearParams } from '~/shared';
import {
  BuscaPatrocinadaProductsDTO,
  BuscaPatrocinadaProductsResponse,
} from '~/types/keywordPerformance';

export const GET_BUSCA_PATROCINADA_PRODUCTS_QUERY_KEY =
  'GET_BUSCA_PATROCINADA_PRODUCTS';

function getBuscaPatrocinadaProducts(params: BuscaPatrocinadaProductsDTO) {
  const clearedParams = clearParams(params as Record<string, unknown>);
  return serviceApi.get<BuscaPatrocinadaProductsResponse>(
    '/RelatorioBuscaPatrocinada/products',
    { params: clearedParams }
  );
}

export function useGetBuscaPatrocinadaProducts(
  params: BuscaPatrocinadaProductsDTO
) {
  return useQuery({
    queryKey: [GET_BUSCA_PATROCINADA_PRODUCTS_QUERY_KEY, params],
    queryFn: () => getBuscaPatrocinadaProducts(params),
    select: data => data.data,
    placeholderData: keepPreviousData,
  });
}
